import {VehicleMarketplaceService} from "@bolteu/bolt-server-api-vehicle-marketplace";
import ApplicationStatus = VehicleMarketplaceService.ApplicationStatus;

export const canRequestVehicle = (status?: ApplicationStatus | null) => {
    if (!status || [ApplicationStatus.DRAFT, ApplicationStatus.INACTIVE].includes(status)) {
        return true;
    }
    return false;
};
